module.exports = __webpack_public_path__ + "img/9.941fe8e6.jpg";